<template>
    <div class="">
        <logo-component></logo-component>

        <section class="account-form">
            <div class="m-page-container">
                <div class="heading">
                    <h4 class="heading__h4">Forgot Password</h4>
                </div>

                <div class="row g-0">
                    <div class="col-12 col-md-6 offset-md-3">
                        <div v-if="errors.length">
                            <b>Please correct the following error(s):</b>
                            <ul>
                                <li  class="alert alert-danger" v-for="error in errors">{{ error }}</li>
                            </ul>
                        </div>
                        <div v-if="show_success" class="alert alert-success" role="alert">
                            Password reset successful.
                            <router-link style="text-decoration: underline;font-weight: bold" to="/sign_in">Sign In</router-link>
                        </div>
                        <div v-if="show_error" class="alert alert-danger" role="alert">
                            {{show_error}}

                        </div>
                        <form method="POST" action="/login">
                            <div class="form-container">
                                <div class="form-element">
                                    <label for="email" class="title">E-Mail Address</label>
                                    <input id="email" type="email" class="" v-model="email" required autofocus>
                                </div>

                                <div class="form-element">
                                    <label for="password" class="title">Password</label>
                                    <input id="password" type="password" class="" v-model="password" required autofocus>
                                </div>

                                <div class="form-element">
                                    <label for="password_confirmation" class="title">Confirm Password</label>
                                    <input id="password_confirmation" type="password" class="" v-model="password_confirmation" required autofocus>
                                </div>


                                <div class="button-container flex-wrapper flex-wrap">
                                    <button type="submit" :disabled="this.loading" class="button pink midsize wide py-3 me-4" @click="handleSubmit">
                                        {{this.loading ? 'Please wait' : 'Reset'}}
                                    </button>

                                </div>

                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </section>

        <footer-component></footer-component>
    </div>
</template>

<script>

    import FooterComponent from './FooterComponent.vue'
    import LogoComponent from "./LogoComponent.vue"

    export default {
        components: { LogoComponent, FooterComponent },
        name: "ResetPasswordComponent",
        data(){
            return {
                email : this.$route.query.email,
                password : "",
                password_confirmation : "",
                show_success: false,
                show_error: false,
                loading: false,
                errors: [],
            }
        },
        methods : {

            validate() {

                this.errors = [];


                if(!this.validateEmailInput(this.email)) {
                    this.errors.push("Valid email required.");
                }

                if (this.password === this.password_confirmation && this.password.length > 0) {

                } else {
                    this.errors.push("Passwords do not match.");
                }

                return this.errors.length == 0;
            },
            resetErrors() {
                this.errors = [];
            },
            resetStatusMessages() {
                this.show_success = this.show_error = false;
            },
            handleSubmit(e) {
                this.resetErrors();
                this.resetStatusMessages();
                e.preventDefault();

                if (this.validate()) {

                    this.loading = true;
                    axios.post(this.apiEndPoints.resetPassword, {
                        token: this.$route.params.token,
                        email: this.email,
                        password: this.password,
                        password_confirmation : this.password_confirmation,

                    })
                        .then(response => {
                            // console.log(response);

                            if(response.data && response.data.status) {

                                if(response.data.status == 'success') {
                                    this.show_success = true;
                                } else if(response.data.message) {
                                    this.show_error = response.data.message;
                                } else {
                                    this.show_error = response.data.message;
                                }
                            }
                        })
                        .catch(error => {
                            console.error(error.response);
                            this.show_error = true;
                            if(error.response.data.message) {
                                this.show_error = error.response.data.message;
                            } else {
                                this.show_error = 'An error occurred. Please try again!';
                            }

                        }).finally(() => {
                        this.loading = false;
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
